import { Box, IconButton, LinearProgress, Paper, Popper } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { calculateValueFromEvent } from "../../components/Utils";
import Icon from '@mdi/react';
import { mdiConsoleLine } from '@mdi/js';
import useApi from "../../api";
import { enviarComando } from "../../api/controlador";
import TextField from "../../components/TextField";
import { isUndefined } from "lodash";

const initialData = {
    comando: '',
}

export default function ComandosSimulacion({ ...props }) {

    const [anchorEl, setAnchorEl] = useState(null);
    const [data, setData] = useState(initialData);

    const [{ data: comandoData, loading: loadingComando }, comandoApi] = useApi();

    const inputRefComando = useRef(null);

    useEffect(() => {
        if (!isUndefined(comandoData)) {
            console.log("[Simulador] Comando enviado...");
            inputRefComando.current.focus();
        }
    }, [comandoData]);

    const handleClick = (event) => {
        setAnchorEl(anchorEl ? null : event.currentTarget);
    };

    const handleChangeValue = name => event => {
        const value = calculateValueFromEvent(event);

        setData({
            ...data,
            [name]: value
        });
    }

    const handleKeyPress = event => {
        if (event.key === "Enter") {
            comandoApi(enviarComando(data));
            setData(initialData);
        }
    };

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popper' : undefined;

    return (
        <>
            <IconButton
                onClick={handleClick}>
                <Icon path={mdiConsoleLine} size={1} />
            </IconButton>
            <Popper id={id} open={open} anchorEl={anchorEl} sx={{ zIndex: 9999 }}>
                <Paper sx={{ border: 1, p: 1, bgcolor: 'background.paper' }}>
                    <TextField
                        fullWidth
                        margin="dense"
                        label="Comando"
                        field="comando"
                        inputRef={inputRefComando}
                        value={data.comando}
                        disabled={loadingComando}
                        onKeyPress={handleKeyPress}
                        onChange={handleChangeValue('comando')}
                    />
                    {loadingComando && <LinearProgress />}
                </Paper>
            </Popper>
        </>
    )
}